function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isNode, isString } from './type';
/**
 * querySelector under steroid
 * Can use as selector:
 *  - function
 *  - DOM Node
 *  - String
 * @param {String|Node|Function} selector 
 * @param {Node|undefined} node 
 */

export var querySelector = function querySelector(selector, node) {
  if (isFunction(selector)) {
    return selector(node);
  }

  if (isNode(selector)) {
    return selector;
  }

  if (isString(selector)) {
    if (!node || !isNode(node) || node.nodeType !== 1) {
      node = document;
    }

    return node.querySelector(selector);
  }

  if (Array.isArray(selector) || typeof NodeList !== 'undefined' && NodeList.prototype.isPrototypeOf(selector)) {
    return selector[0];
  }
};
/** 
 * querySelectorAll under steroid
 * Can use as selector:
 *  - function
 *  - DOM Node
 *  - String
 * @param {String|Node|Function} selector 
 * @param {Node|undefined} node 
 */

export var querySelectorAll = function querySelectorAll(selector, node) {
  if (isFunction(selector)) {
    return selector(node);
  }

  if (isNode(selector)) {
    return [selector];
  }

  if (isString(selector)) {
    if (!node || !isNode(node) || node.nodeType !== 1) {
      node = document;
    }

    return node.querySelectorAll(selector);
  }

  if (typeof NodeList !== 'undefined' && NodeList.prototype.isPrototypeOf(selector)) {
    return selector;
  } else {
    return [];
  }
}; // Convert dataset into Object

export var optionsFromDataset = function optionsFromDataset(node) {
  var defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isNode(node)) {
    return node.dataset ? Object.keys(node.dataset).filter(function (key) {
      return Object.keys(defaultOptions).includes(key);
    }).reduce(function (obj, key) {
      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, node.dataset[key]));
    }, {}) : {};
  } else {
    return {};
  }
};
/**
 * Copy HTML attributes from a source element to a target element
 * @param {Node} target 
 * @param {Node} source 
 * @param {String} except list of attributes to skip (separated by space)
 */

export var cloneAttributes = function cloneAttributes(target, source) {
  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (except !== null) {
    except = except.split(' ');
  }

  _toConsumableArray(source.attributes).forEach(function (attr) {
    if (!except.includes(attr.nodeName)) {
      target.setAttribute(attr.nodeName === "id" ? 'data-id' : attr.nodeName, attr.nodeValue);
    }
  });
};
/**
 * Escapes string for insertion into HTML, replacing special characters with HTML
 * entities.
 * @param {String} string
 */

export var escape = function escape(string) {
  return isString(string) ? string.replace(/(['"<>])/g, function (char) {
    return {
      '<': "&lt;",
      '>': "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }[char];
  }) : string;
};